export const PaletteDark = {
  primary: {
    main: "#168FEE",
    light: "#90CAF9",
    dark: "#42A5F5",
    contrast: "#000000"
  },
  secondary: { main: "#5ec891", light: "#5ec891" },
  warning: { main: "#FFA726", contrast: "#000000" },

  background: {
    default: "#121212",
    sidePanel: "#252525",
    rightSidePanel: "#252525",
    paper: "#1c2d39",
    readerBar: "#66BB69",
    studentView: "#1c2d39"
  },
  card: {
    background: {
      disabled: "#2e2e2e"
    },
    text: {
      disabled: "#7b7b7b"
    }
  },

  text: {
    primary: "#FFFFFF",
    blue: "#BCD9F1",
    green: "#5EC891",
    disabled: "#EEEEEE",
    secondary: "rgba(255, 255, 255, 0.6)"
  },

  blue: {
    main: "#168fee",
    primary: "#42A5F5",
    babyBlue: "#2196F31A",
    secondary: "#90CAF9",
    babyLight: "#EDF2F41F",
    tertiary: "#90CAF9"
  },
  lightText: {
    main: "#000000",
    muted: "#FFFFFF8F"
  },
  grey: {
    main: "#1c2d39 70%",
    selected: "#FFFFFF2E",
    border: "#FFFFFF38",
    paper: "#373742",
    surface: "#19222E",
    toggleGrey: "#FFFFFFCC"
  },
  newText: {
    secondary: "#FFFFFFCC"
  },
  snackbar: {
    background: "rgba(250, 250, 250, 1)",
    text: "rgba(0, 0, 0, 0.6)",
    button: "rgba(0, 0, 0, 0.87)"
  },
  border: {
    main: "rgba(255, 255, 255, 0.3)",
    secondary: "#7E7E7E"
  },
  pieChart: {
    SubmissionPending_no: "#495761",
    SubmissionMissed_total: "#EF5350",
    SubmissionMissed_incomplete: "#EF5350",
    SubmissionMissed: "#EF5350",
    SubmissionMissed_no: "#EF5350",
    SubmissionPending_total: "#495761",
    SubmissionPending_complete: "#495761",
    SubmissionPending: "#495761",
    SubmissionLate_complete: "#C8E6C9",
    SubmissionLate_incomplete: "#FF9800",
    SubmissionOnTime_complete: "#388E3C",
    SubmissionOnTime_incomplete: "#81C784",
    REVIEW_SESSION_total: "#90CAF9",
    HIGHLIGHT_SESSION_total: "#D7EEFF",
    ANSWER_SESSION_total: "#42A5F5"
  },
  textEditor: {
    border: "rgba(255, 255, 255, 0.23)",
    placeholder: "rgba(255, 255, 255, 0.7)",
    bubbleMenu: {
      border: "rgba(229, 231, 235, 0.3)",
      inactiveBackgorund: "#121212",
      inactiveHover: "rgba(255, 255, 255, 0.1)",
      activeBackgorund: "rgba(255, 255, 255, 0.1)",
      activeHover: "rgba(255, 255, 255, 0.05)"
    }
  },
  engagementChip: {
    Low: { background: "#D32F2F", color: "#FFFFFF" },
    Moderate: { background: "#ED6C02", color: "#FFFFFF" },
    High: { background: "#2E7D32", color: "#FFFFFF" },
    VeryHigh: { background: "#1B5E20", color: "#FFFFFF" },
    teacher: { background: "#1565C0", color: "#FFFFFF" },
    risk: {
      background: "rgba(211, 47, 47, 0.12)",
      color: "#FFFFFF"
    }
  }
};
